import React from 'react';
import { CreateRequestEntry } from '@/features/request-gateway';

interface Props {
  onClose: () => void;
  onNavigate?: (key: string) => void;
}

/** Canonical Create Request Hub entry for Author cabinet (Block 03 / U153). */
export const AuthorCreateHubOverlay: React.FC<Props> = ({ onClose }) => {
  return (
    <CreateRequestEntry
      isOpen
      onClose={onClose}
      onBack={onClose}
      activeRole="AUTHOR"
      roleLabel="Автор / соавтор"
    />
  );
};
